module.exports = __webpack_public_path__ + "assets/img/ticket2.png";